/* unplugin-vue-components disabled */import { render } from "./GHSeparator.vue?vue&type=template&id=524e9c75&scoped=true"
import script from "./GHSeparator.vue?vue&type=script&lang=js"
export * from "./GHSeparator.vue?vue&type=script&lang=js"

import "./GHSeparator.vue?vue&type=style&index=0&id=524e9c75&scoped=true&lang=css"

import exportComponent from "/home/runner/work/gh-docs-frontend/gh-docs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524e9c75"]])

export default __exports__